import Box from "@mui/material/Box";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import ActionBar from "./components/ActionBar";
import AddModelModal from "./components/AddModelModal";
import ModelTable from "./components/ModelTable";
import {
  selectIsModelListFiltered,
  selectyearFilteredData,
  selectManufacturerModelsLoading,
  selectManufacturerModelsMeta,
} from "./redux/selector";
import { manufacturerModelSaga } from "./redux/saga";
import {
  manufacturerModelActions,
  reducer,
  sliceKey,
} from "./redux/slice";
import { useStyles } from "./styles";

const ManufacturerModel = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: manufacturerModelSaga,
  });

  const rows = useSelector(selectyearFilteredData);
  const loading = useSelector(selectManufacturerModelsLoading);
  const meta = useSelector(selectManufacturerModelsMeta);
  const isListFiltered = useSelector(selectIsModelListFiltered);

  useEffect(() => {
    dispatch(manufacturerModelActions.getManufacturerModelsList());
  }, [dispatch]);

  const hasMoreItems =
    !isListFiltered && meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(manufacturerModelActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
        <Box className={styles.scrollContent} dir={i18n.dir()}>
          <Box className={styles.pageContent}>
            <BreadCrumb
              title={t("SIDEBAR.MODEL_PER_MANUFACTURER")}
              iconPosition="end"
            />
            <ActionBar
              onAddClick={() => dispatch(manufacturerModelActions.openAddModal())}
            />
            <Box className={styles.tableContainer}>
              <ScrollableView
                borderless
                height="calc(100vh - 200px)"
                loadMore={getNextPage}
                hasMoreItems={hasMoreItems}
              >
                <ModelTable rows={rows} loading={loading && rows.length === 0} />
              </ScrollableView>
            </Box>
          </Box>
        </Box>
      <AddModelModal />
    </Box>
  );
};

export default ManufacturerModel;
